module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-fukuoka-1-447d91e610ab11027e4758d416b53fef.png";